import { useEffect } from 'react';

import ForwardArrowIcon from '@/shared-components/icons/components/public/ForwardArrowIcon';

import './styles/SliderControls.css';

export function PrevButton({ className="", onClick }) {

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'ArrowUp') {
        if (onClick) {
          onClick();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClick]);

  return (
    <>
      <div tabIndex={0} className={`slider-controls__button ${className}`} onClick={onClick}>
        <ForwardArrowIcon className="slider-controls__button-icon prev"/>
      </div>
    </>
  );
}

export function NextButton({ className="", onClick }) {

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'ArrowDown') {
        if (onClick) {
          onClick();
        }      
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClick]);

  return (
    <>
      <div tabIndex={0} className={`slider-controls__button ${className}`} onClick={onClick}>
        <ForwardArrowIcon className="slider-controls__button-icon next"/>
      </div>
    </>
  );
}
